import { AbstractQueryAction, ActionData } from '../../http/data_query';
import { ManyRelationsWithDocuments } from './common';
import { normalizeSchemaName } from '../tools';

export class CreateBuilder implements AbstractQueryAction {

  manyRelationsForCreate: ManyRelationsWithDocuments = {};

  constructor(
    private queryName: string | null,
    private schemaName: string | null,
    private document: any
  ) { }

  withManyRelation(schemaName: string, relatedField: string, buildDocuments: Function) {
    this.manyRelationsForCreate[`${normalizeSchemaName(schemaName)}/${relatedField}`] = buildDocuments(function(document: any) {
      return new CreateBuilder(null, null, document);
    });

    return this;
  }

  serialize(): ActionData {
    const query: any = {
      action: 'documents.create',
      name: this.queryName,
      params: {
        schema_id: normalizeSchemaName(this.schemaName),
        document: this.document
      }
    };

    if (Object.keys(this.manyRelationsForCreate).length > 0) {
      query.params.create_related = {};

      for (const key in this.manyRelationsForCreate) {
        query.params.create_related[key] = this.manyRelationsForCreate[key].map(builder => builder.serializeEmbed());
      }
    }
    return query;
  }

  serializeEmbed() {
    return {
      document: this.document
    };
  }
}
